/*
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：JS 函数封装
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
*/

// 引入全局工具函数
import { globalUtils, constants, defaultConfig } from '../utils/globalUtils'

// apiModule.js
// API访问模块
export const func_readapi_jj = (s_url, j_post, isjson = 0, bool_state = false) => {
	// globalUtils.getBaseUrl(true,false,false,3)
    //const api_url =  window.location.protocol + "//unit.ioe.top/open/api/2.0.1/";
	const api_url =  globalUtils.getBaseUrl(true,false,false,3) + "/open/api/2.0.1/";
    
        const xhr = new XMLHttpRequest();
        
        xhr.open("POST", api_url + s_url, bool_state);
        
        if (isjson == 0) {
            xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        } else {
            xhr.setRequestHeader('Content-type', 'application/json');
        }
        
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    try {
                        const response = JSON.parse(xhr.responseText);
                        resolve(response);
                    } catch (e) {
                        //reject(new Error('Failed to parse response as JSON'));
                    }
                } else {
                    //reject(new Error(`Request failed with status ${xhr.status}`));
					return false;
                }
            }
        };
        
        xhr.onerror = function() {
            //reject(new Error('Network error'));
			return false;
        };
        
        const s_post = JSON.stringify(j_post, null, 0);
        xhr.send(s_post);
        
        // 如果是同步请求，直接返回结果
        if (!bool_state) {
            if (xhr.readyState == 4 && xhr.status == 200) {
                try {
                    return JSON.parse(xhr.responseText);
                } catch (e) {
					console.error(xhr.responseText);
                    //reject(new Error('Failed to parse response as JSON'));
					return false;
                }
            } else if (xhr.readyState == 4) {
                //reject(new Error(`Request failed with status ${xhr.status}`));
				return false;
            }
        }

}

export const enterFullscreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { // Firefox
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { // Chrome, Safari and Opera
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { // IE/Edge
      elem.msRequestFullscreen();
    }
}

export const loadFontAwesome = () => {
	// 检查是否已加载Font Awesome
	// 清理
	const fontAwesomeLinks = document.querySelectorAll('link[href*="font-awesome"]');
	if (fontAwesomeLinks.length > 0) {
		fontAwesomeLinks.forEach(link => link.parentNode.removeChild(link));
	}
	// 重新加载
	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
	document.head.appendChild(link);
}

export const loadCSS = (href) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}

export const loadScript = (src, callback) => {
  const script = document.createElement('script');
  script.src = src;
  script.onload = callback;
  document.head.appendChild(script);
}

// 获得文件扩展名
export const extractFileExt = (url) => {
	try {
		let extension = "";
		// 创建URL对象
		const urlObj = new URL(url);
		
		if(urlObj)
		{
			// 获取路径名
			const pathname = urlObj.pathname;
			
			if(pathname)
			{
				// 从路径中提取文件名
				const filename = pathname.split('/').pop();
				
				// 如果没有文件名或文件名没有扩展名
				if (!filename || !filename.includes('.')) {
					return '';
				}
			}
			
			// 提取扩展名并转换为小写
			extension = filename.split('.').pop().toLowerCase();
		}
		
		return extension;
	} catch (error) {
		// 如果URL无效，尝试直接处理字符串
		const parts = url.split('/');
		const lastPart = parts.pop();
		
		if (lastPart && lastPart.includes('.')) {
			return lastPart.split('.').pop().toLowerCase();
		}
		
		return '';
	}
}

// 切换标签
export const switchTab = (cur) => {
            // 获取所有导航项
            const navItems = document.querySelectorAll('.mobile-nav-item');
			const curItem = document.getElementById(cur);
			
            // 为每个导航项添加点击事件
			if(curItem)
			{
                    // 移除所有active类
                    navItems.forEach(nav => {
                        nav.classList.remove('active');
                    });
                    
                    // 为当前项添加active类
                    curItem.classList.add('active');
                    
                    // 获取页面名称
                    const page = curItem.getAttribute('data-page');
                    
                    // 更新演示内容
                    //demoContent.innerHTML = `当前显示：${pageNames[page]}`;
                    
                    // 这里可以添加实际页面切换的逻辑
                    console.log(`切换到页面: ${page}`);
					
					if(page == "profile")
					{
						document.getElementById("mainAside").classList.toggle('hidden');
					}
			}
}

// 格式化文件大小单位
export const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 B';
    
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const base = 1024;
    const exponent = Math.floor(Math.log(bytes) / Math.log(base));
    const size = bytes / Math.pow(base, exponent);
    const unit = units[exponent];
    
    // 保留两位小数，并移除多余的尾随零
    return size.toFixed(2).replace(/\.00$|0$/, '') + ' ' + unit;
}

/**
  * 防抖函数
  */
export const debounce = (func, wait) => {
	let timeout
	return function executedFunction(...args) {
		const later = () => {
			clearTimeout(timeout);
			func(...args);
		}
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	}
}

/**
  * 节流函数
  */
export const throttle = (func, limit) => {
	let inThrottle
	return function(...args) {
		if (!inThrottle) {
			func.apply(this, args);
			inThrottle = true;
			setTimeout(() => inThrottle = false, limit);
		}
	}
}

/**
  * 验证邮箱格式
  */
export const validateEmail = (email) => {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(email);
}

/**
  * 验证手机号格式
  */
export const validatePhone = (phone) => {
	const re = /^1[3-9]\d{9}$/;
	return re.test(phone);
}

// 隐藏部分字符
export const maskString = (str) => {
    if (!str || str.length === 0) {
        return "无";
    }
    else if (str.length === 1) {
        return str;
    }
    
    const length = str.length;
    
    // 计算需要替换的字符数量（至少30%，最少1个）
    const replaceCount = Math.max(1, Math.ceil(length * 0.3));
    
    // 计算开始替换的位置（居中）
    const startIndex = Math.floor((length - replaceCount) / 2);
    
    // 构建新字符串
    const maskedStr = 
        str.substring(0, startIndex) + 
        '*'.repeat(replaceCount) + 
        str.substring(startIndex + replaceCount);
    
    return maskedStr;
}

// 默认导出
export default func_readapi_jj;